import { useState } from "react";
import { List, ChevronRight } from "lucide-react";
import { TOC_SOUTH_FLORIDA_POOL_REMODELING_GUIDE } from "@/data/southFloridaPoolRemodelingGuideData";

export function TableOfContents() {
  const [tocOpen, setTocOpen] = useState(true);
  const tocItems = TOC_SOUTH_FLORIDA_POOL_REMODELING_GUIDE;

  return (
    <div className="my-10 bg-card border border-border rounded-xl p-6 shadow-xs">
      <button
        onClick={() => setTocOpen(!tocOpen)}
        className="flex items-center justify-between w-full text-left font-bold text-lg text-[#0B1F3D]"
      >
        <span className="flex items-center gap-2">
          <List className="w-5 h-5 text-[#00A3D9]" />
          Table of Contents
        </span>
        <span className="text-xs text-[#00A3D9] font-medium underline">
          {tocOpen ? "Hide" : "Show"}
        </span>
      </button>
      {tocOpen && (
        <ul className="mt-4 space-y-2 border-t border-border pt-4 text-sm text-foreground">
          {tocItems.map((item, idx) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className="flex items-center gap-2 text-muted-foreground hover:text-[#00A3D9] transition-colors"
              >
                <ChevronRight className="w-3.5 h-3.5 text-[#00A3D9] shrink-0" />
                <span>
                  {idx + 1}. {item.title}
                </span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
